import api from "PFCore/api";
import { ProfileNotificationSetting } from "PFTypes";

export const fetchProfileNotificationSettings = () =>
  api<ProfileNotificationSetting[]>({
    url: "profile_notification_settings"
  });
